import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  color: #fff;
  background-color: ${props => props.theme.palette.common.black};
  box-shadow: ${props => props.theme.shadows[6]};
`;